import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AdminCategoriesList } from '../../../../components/admin-dashboard-component/categories/admin-categories-list/admin-categories-list';

@Component({
  selector: 'app-view-all-categories',
  imports: [AdminCategoriesList, RouterLink],
  templateUrl: './view-all-categories.html',
  styleUrl: './view-all-categories.scss',
})
export class ViewAllCategories {}
